import Icon from '../components/Icon.vue'

Icon.register({
  'play-circle': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM371.7 280c16.4-9.1 16.4-32.8 0-42l-176-107c-15.9-8.8-35.7 2.6-35.7 21v208c0 18.5 19.9 29.8 35.7 21z'
      }
    ]
  }
})
